import { z } from 'zod'
import type { SlimModel } from '../../models/SlimModel'

export const SlimModelDTO = z.object({
  id: z.number().optional(),
  name: z.string()
})

export type SlimModelDTO = z.infer<typeof SlimModelDTO>

export function mapSlimModelToDTO (model: SlimModel): SlimModelDTO {
  return {
    id: model.id,
    name: model.name
  }
}

export function mapDTOToSlimModel (dto: SlimModelDTO): SlimModel {
  return {
    id: dto.id,
    name: dto.name
  }
}
